import { render } from "./questioneditorgfair.vue?vue&type=template&id=38187d94&scoped=true"
import script from "./questioneditorgfair.vue?vue&type=script&lang=js"
export * from "./questioneditorgfair.vue?vue&type=script&lang=js"

import "./questioneditorgfair.vue?vue&type=style&index=0&id=38187d94&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38187d94"]])

export default __exports__